import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import BlockWrapper from '@v2/pages/machines/modules/now/components/Overview/components/BlockWrapper';
import { MACHINES_NOW_OVERVIEW_BLOCK_CONFIG, TOP_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { scale } from '@components/frame';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import TouchableElement from '@components/common/touchableElement';
import { font } from '@styles/fonts';
import NCFileFirstRanInfo from '@components/common/NCFileFirstRanInfo';
import Separator from '@components/common/Separator';
import TopBlockHeader from './components/TopBlockHeader';
import TopBlockHeaderCard from './components/TopBlockHeaderCard';
import TopBlockSeparator from './components/TopBlockSeparator';
import { BaseTopBlockProps, NCFileFirstRanInfoProp, NCFileNameProp, OnModifyNCFileTypePressProp } from './types';

export interface ChangeOrIgnoredNCFileTopBlockProps extends BaseTopBlockProps, NCFileFirstRanInfoProp, NCFileNameProp, OnModifyNCFileTypePressProp {}

const ChangeOrIgnoredNCFileTopBlock: FC<ChangeOrIgnoredNCFileTopBlockProps> = ({ C, ncFileFirstRanInfo, ncFileName, onModifyNCFileTypePress }) => {
  const { paddingHorizontal } = MACHINES_NOW_OVERVIEW_BLOCK_CONFIG;
  const { paddingVertical, changeNCFileTypeButtonPaddingBottom } = TOP_BLOCK_CONFIG;

  return (
    <BlockWrapper testID={TEST_IDS.liveScreen.topBlockChangeIgnored} containerStyle={{ flex: 1, paddingHorizontal: 0 }}>
      <TopBlockHeaderCard C={C}>
        <TopBlockHeader C={C} ncFileName={ncFileName} />
      </TopBlockHeaderCard>

      <TopBlockSeparator C={C} />

      <View style={{ marginTop: scale(paddingVertical) }}>
        <View style={{ paddingHorizontal: scale(paddingHorizontal) }}>
          <NCFileFirstRanInfo
            containerStyle={{ marginTop: 0, alignItems: 'flex-start' }}
            firstRanByMachineName={ncFileFirstRanInfo?.firstRanByMachineName || ''}
            firstRanOn={ncFileFirstRanInfo?.firstRanOn || ''}
            color="Label/Light/Tertiary"
            fontType="Body"
          />

          <Separator C={C} containerStyle={{ marginTop: scale(paddingVertical) }} />
        </View>

        <TouchableElement testID={TEST_IDS.liveScreen.topBlockModifyButton} onPress={onModifyNCFileTypePress}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  backgroundColor: C(pressHoverColor('Button/Light/Only Text')),
                  paddingTop: scale(paddingVertical),
                  paddingBottom: scale(changeNCFileTypeButtonPaddingBottom),
                  paddingHorizontal: scale(paddingHorizontal),
                  borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
                  borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
                },
              ]}
            >
              <Text style={[font.Body, { color: C('Link/Light/Primary') }]}>{i18n.t('Modify NC File Type')}</Text>
            </View>
          )}
        </TouchableElement>
      </View>
    </BlockWrapper>
  );
};

export default ChangeOrIgnoredNCFileTopBlock;
